"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BENCHMARK_STATS_FRAGMENT = exports.typeDef = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.typeDef = (0, graphql_tag_1.default) `
  type Benchmark {
    top20: Float!
    average: Float!
    top80: Float!
  }

  type DeveloperAnalyticsBenchmarks {
    activePlayers: Benchmark!
    newPlayers: Benchmark!
    totalLtp: Benchmark!
    weekLtp: Benchmark!
    totalPlayings: Benchmark!
    playingsTime: Benchmark!
    loadingsTime: Benchmark!
    classicD1: Benchmark!
    classicD7: Benchmark!
    classicD15: Benchmark!
    impressions: Benchmark!
    clicks: Benchmark!
    ctr: Benchmark!
    conversion: Benchmark!
  }
`;
exports.BENCHMARK_STATS_FRAGMENT = (0, graphql_tag_1.default) `
  fragment BenchmarkFragment on Benchmark {
    top20
    average
    top80
  }

  fragment BenchmarkStatsFragment on DeveloperAnalyticsBenchmarks {
    activePlayers {
      ...BenchmarkFragment
    }
    newPlayers {
      ...BenchmarkFragment
    }
    totalLtp {
      ...BenchmarkFragment
    }
    weekLtp {
      ...BenchmarkFragment
    }
    totalPlayings {
      ...BenchmarkFragment
    }
    playingsTime {
      ...BenchmarkFragment
    }
    loadingsTime {
      ...BenchmarkFragment
    }
    classicD1 {
      ...BenchmarkFragment
    }
    classicD7 {
      ...BenchmarkFragment
    }
    classicD15 {
      ...BenchmarkFragment
    }
    impressions {
      ...BenchmarkFragment
    }
    clicks {
      ...BenchmarkFragment
    }
    ctr {
      ...BenchmarkFragment
    }
    conversion {
      ...BenchmarkFragment
    }
  }
`;
exports.default = exports.typeDef;
